import React from 'react';
import { Box } from '@mui/material';
import { useAppTheme } from '../../context/theme.context';

const AnimatedBackground = () => {
  const { isDark } = useAppTheme();

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: isDark ? 0.75 : 0.6,
          zIndex: 0,
          backgroundSize: '40px 40px',
          maskImage: 'radial-gradient(ellipse at center, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 45%)',
          WebkitMaskImage: 'radial-gradient(ellipse at center, rgba(0,0,0,1) 0%, rgba(0,0,0,0) 45%)',
        }}
      />
    </>
  );
};

export default AnimatedBackground;
